/**
 * 1 second in milliseconds
 */
export const T_SEC = 1000;

/**
 * 1 minute in milliseconds
 */
export const T_MIN = 60_000;

/**
 * 1 hour in milliseconds
 */
export const T_HOUR = 3_600_000;

/**
 * 1 day in milliseconds
 */
export const T_DAY = 86_400_000;

window.T_SEC = T_SEC;
window.T_MIN = T_MIN;
window.T_HOUR = T_HOUR;
window.T_DAY = T_DAY;

declare global {
  interface Window {
    T_SEC: 1000; // 1sec
    T_MIN: 60_000; // 1min
    T_HOUR: 3_600_000; // 1h
    T_DAY: 86_400_000; // 24h
  }

  const T_SEC: 1000; // 1sec
  const T_MIN: 60_000; // 1min
  const T_HOUR: 3_600_000; // 1h
  const T_DAY: 86_400_000; // 24h
}
